Number.prototype.toFixed = function (n) {
    if (n > 20 || n < 0) {
        throw new RangeError('toFixed() digits argument must be between 0 and 20');
    }
    var number = this;
    if (isNaN(number) || number >= Math.pow(10, 21)) {
        return number.toString();
    }
    if (typeof (n) == 'undefined' || n == 0) {
        return (Math.round(number)).toString();
    }
    var result = number.toString();
    var arr = result.split('.');
    if (arr.length < 2) {
        result += '.';
        for (var i = 0; i < n; i += 1) {
            result += '0';
        }
        return result;
    }
    var integer = arr[0];
    var decimal = arr[1];
    if (decimal.length == n) {
        return result;
    }
    if (decimal.length < n) {
        for (var i = 0; i < n - decimal.length; i += 1) {
            result += '0';
        }
        return result;
    }
    result = integer + '.' + decimal.substr(0, n);
    var last = decimal.substr(n, 1);
    if (parseInt(last, 10) >= 5) {
        var x = Math.pow(10, n);
        result = (Math.round((parseFloat(result) * x)) + 1) / x;
        result = result.toFixed(n);
    }
    return result;
};
Number.prototype.toFixedNoZero = function (digit) {
    var temp = this.toFixed(digit);
    var tempArr = temp.split('.');
    if (tempArr.length == 2) {
        var dotAfter = tempArr[1].split('');
        for (var i = dotAfter.length - 1; i >= 0; i--) {
            if (dotAfter[i] != "0") {
                break;
            }
            dotAfter[i] = '';
        }
        var dotAfterStr = dotAfter.join('');
        if (dotAfterStr) {
            temp = tempArr[0] + "." + dotAfter.join('');
        }
        else {
            temp = tempArr[0];
        }
    }
    return temp;
};
Number.prototype.toFixedNoZeroNumber = function (digit) {
    var temp = this.toFixed(digit);
    var tempArr = temp.split('.');
    if (tempArr.length == 2) {
        var dotAfter = tempArr[1].split('');
        for (var i = dotAfter.length - 1; i >= 0; i--) {
            if (dotAfter[i] != "0") {
                break;
            }
            dotAfter[i] = '';
        }
        var dotAfterStr = dotAfter.join('');
        if (dotAfterStr) {
            temp = tempArr[0] + "." + dotAfter.join('');
        }
        else {
            temp = tempArr[0];
        }
    }
    return parseFloat(temp);
};
String.prototype.toDate = function () {
    return new Date(this.replace(/-/g, "/"));
};
Number.prototype.naNToZero = function () {
    if (isNaN(this))
        return 0;
    return parseFloat(this);
};
Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "h+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        "S": this.getMilliseconds()
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
};
